import http from "../utils/http";
//
/**
 *  @parms resquest 请求地址 例如：http://197.82.15.15:8088/request/...
 *  @param '/testIp'代表vue-cil中config，index.js中配置的代理
 */
let resquest = "/testIp/request/";

/*
 * 登录
 * */
// post请求
export function login(params) {
    return http.post(`register/login`, params);
}
/*
 * 注册用户
 * */
export function register(params) {
    return http.post(`register/index`, params);
}
/*
 * 注册页面用户协议
 * */
export function userAgreement(params) {
    return http.get(`/register/xy`, params);
}
/*
 * 忘记密码
 * */
export function forgetpwd(params) {
    return http.post(`/register/forgetpwd`, params);
}
/*
 * 退出登录-缺接口
 * */
export function logout(params) {
    return http.post(`register/login`, params);
}

// get请求
export function getListAPI(params) {
    return http.get(`${resquest}/getList.json`, params);
}
// post请求
export function postFormAPI(params) {
    return http.post(`${resquest}/postForm.json`, params);
}
// put 请求
export function putSomeAPI(params) {
    return http.put(`${resquest}/putSome.json`, params);
}
// delete 请求
export function deleteListAPI(params) {
    return http.delete(`${resquest}/deleteList.json`, params);
}

// 获取品类信息(通用)
export function goodsgetCategory(params) {
    return http.get(`/admin/goods/getAllCategory`, params);
}

// 获取地区-省市区
export function admingetRegion(params) {
    return http.get(`/admin/getRegion`, params);
}
// 获取客户标签
export function admingetAllLable(params) {
    return http.get(`/admin/lable/getAllLable`, params);
}

// 获取全部地区及下级地区
export function getAllRegion(params) {
    return http.get(`/admin/getAllRegion`, params);
}

